const state = {
  token: '',
  login: false,
  datosPerfil: {},
}

export default state